import {
  getRawCreatorCancellation,
  hasCreatorCancellation,
} from "@/biz/orderCancellation";
import {
  CollaborationCancellation,
  CreatorCancellationOrder,
} from "@/interface/collaborationCancellation";
import { fromApiCancellationReasonCode } from "@/biz/orderCancellationReason";

export { fromApiCancellationReasonCode };

const getRefund = (
  order: CreatorCancellationOrder,
): CollaborationCancellation["refund"] => {
  const refundAmount = order.refund?.amount ?? order.refundAmount;
  if (typeof refundAmount !== "number" || !Number.isFinite(refundAmount)) {
    return undefined;
  }

  return {
    amount: refundAmount,
    currency: order.refund?.currency || "USD",
    triggeredAt: order.refund?.triggeredAt,
    sources: order.refund?.sources,
  };
};

export const getCollaborationCancellationFromOrder = (
  order?: CreatorCancellationOrder | null,
): CollaborationCancellation | null => {
  if (!hasCreatorCancellation(order)) return null;
  const raw = getRawCreatorCancellation(order);

  return {
    orderId: String(order?.id || order?._id || ""),
    reasonCode: fromApiCancellationReasonCode(raw?.reasonCode),
    note: raw?.notes || "",
    cancelledAt: raw?.submittedAt || order?.cancelledAt || "",
    refund: getRefund(order || {}),
  };
};

export const isCreatorCancellation = (
  order?: CreatorCancellationOrder | null,
) => hasCreatorCancellation(order);
